<template>
    <v-layout row wrap v-redirect-if-no-permission:VIEW_OPERATOR_KPI>
        <loading-component :value="loading"/>
        <v-flex xs12>
            <v-tabs
                    fixed-tabs
                    v-model="mode"
                    color="cyan"
                    dark
                    grow
                    slider-color="yellow"
            >
                <v-tab key="week" value="mode">
                    This Week
                </v-tab>
                <v-tab key="month" value="month">
                    This Month
                </v-tab>
                <v-tab key="ever" value="ever">
                    Ever
                </v-tab>
            </v-tabs>
        </v-flex>
        <v-flex xs4>
            <ejs-chart id="container" title='Delay' :primaryXAxis='{valueType: "Category"}'
                       :zoomSettings="{enableSelectionZooming: true}"
            >
                <e-series-collection>
                    <e-series :dataSource='delaySeries'
                              boxPlotMode="Normal"
                              type='BoxAndWhisker' xName='x' yName='y'
                              :marker='{visible: true}'></e-series>
                </e-series-collection>
            </ejs-chart>
        </v-flex>
        <v-flex xs4>
            <ejs-chart id="container2" title='Ticket Lifetime' :primaryXAxis='{valueType: "Category"}'
                       :zoomSettings="{enableSelectionZooming: true}"
            >
                <e-series-collection>
                    <e-series :dataSource='ticketLifetimeSeries'
                              boxPlotMode="Normal"
                              type='BoxAndWhisker' xName='x' yName='y'
                              :marker='{visible: true}'></e-series>
                </e-series-collection>
            </ejs-chart>
        </v-flex>
        <v-flex xs4 v-for="(v,bar) of bars">
            <v-widget :title="bar">
                <div slot="widget-content">
                    <bar-chart :x-labels="xLabels"
                               :datasets="barData[bar]"
                               :stacked="true"
                    />
                </div>
            </v-widget>
        </v-flex>
        <v-flex xs4 v-if="!!data">
            <v-widget title="Cancellation before Limit">
                <div slot="widget-content">
                    <generic-doughnut :data="pieData.cancellation"/>
                </div>
            </v-widget>
        </v-flex>
        <v-flex xs4 v-if="!!data">
            <v-widget title="Reject Against AI">
                <div slot="widget-content">
                    <generic-doughnut :data="pieData.rejection"/>
                </div>
            </v-widget>
        </v-flex>
    </v-layout>
</template>

<script>
    import LoadingComponent from "@/components/LoadingComponent";
    import VWidget from '@/components/VWidget';
    import BarWithGrouping from "@/components/widgets/statistic/BarWithGrouping";
    import BarChart from "@/components/widgets/statistic/BarChart";
    import GenericDoughnut from "@/components/widgets/statistic/GenericDoughnut";
    import {BoxAndWhiskerSeries, Category, Zoom} from "@syncfusion/ej2-vue-charts";


    const colors = ["#F00", "#0F0", "#F0F",
        "#0FF", "#FF0", "#0F0F0F",
        "#00F"];

    const modes = ['week', 'month', 'ever'];
    const bars = {
        "Booking Reject Rate": {
            "Reject Rate": "rejection_rate",
            "Cancel Rate": "cancellation_rate"
        },
        // "Bookings Average Delay": { This is a serie of data now
        //     "Avg Delay": 'avg_delay'
        // },
        // "Approve Delta(minute)": {
        //     "delta": "approved_delta"
        // },
        "Tickets": {
            "Tickets Resolved": "tickets_resolved",
            'Active Tickets': "active_tickets"
        },
        // "Average Ticket Lifetime": { This is a serie of data now
        //     "Lifetime": "avg_ticket_lifetime_hour"
        // }

    };
    const barColors = {
        tickets_resolved: "red",
        active_tickets: "green",
        avg_ticket_lifetime_hour: "blue",
        rejection_rate: "red",
        cancellation_rate: "orange",
        avg_delay: "red",
        approved_delta: "green"
    };
    export default {

        name: "CompetitiveCharts",
        components: {BarChart, LoadingComponent, VWidget, BarWithGrouping, GenericDoughnut},
        title: "Operator KPI",
        provide: {
            chart: [BoxAndWhiskerSeries, Category, Zoom]
        },
        data() {
            return {
                loading: false,
                data: null,
                mode: 0
            }
        },
        computed: {
            ticketLifetimeSeries() {
                if (!this.data)
                    return [];
                return Object.keys(this.data.users).map(
                    user => ({
                        x: user,
                        y: this.data.users[user][modes[this.mode]].avg_ticket_lifetime_hour.map(i => {
                            const key = Object.keys(i)[0];
                            return i[key];
                        })
                    })
                )
            },
            delaySeries() {
                if (!this.data)
                    return [];
                return Object.keys(this.data.users).map(
                    user => ({
                        x: user,
                        y: this.data.users[user][modes[this.mode]].avg_delay.map(i => {
                            const key = Object.keys(i)[0];
                            return i[key];
                        })
                    })
                )
            },
            bars() {
                return bars
            },
            modeData() {
                if (!this.data)
                    return {};
                const mode = modes[this.mode];
                return Object.assign({},
                    ...Object.keys(this.data.users).map(key => ({[key]: this.data.users[key][mode]}))
                );
            },
            pieData() {
                if (!this.data)
                    return {};

                const mode = modes[this.mode];
                return {
                    'cancellation': {
                        datasets: [{
                            data: this.data.cancellation[mode].map(i => i.count),
                            backgroundColor: this.data.cancellation[mode].map
                            ((k, i) => colors[i % colors.length])
                        }],
                        labels: this.data.cancellation[mode].map(i => i.category)
                    },
                    'rejection': {
                        datasets: [{
                            data: this.data.rejection[mode].map(i => i.count),
                            backgroundColor: this.data.rejection[mode].map
                            ((k, i) => colors[i % colors.length])
                        }],
                        labels: this.data.rejection[mode].map(i => i.category)
                    }
                };
            },
            xLabels() {
                return Object.keys(this.modeData);
            },
            barData() {
                const barsTitles = Object.keys(bars);
                return Object.assign(
                    {},
                    ...barsTitles.map(bar => {
                        const titles = Object.keys(bars[bar]);

                        const dataset = titles.map(
                            title => {
                                const key = bars[bar][title];
                                return {
                                    "label": title,
                                    "data": Object.values(this.modeData).map(i => i[key]).map(k => !k ? 0 : parseFloat(k).toFixed(2)),
                                    "fill": false,
                                    "backgroundColor": barColors[key],
                                    "borderColor": "black",
                                    "borderWidth": 1
                                }
                            }
                        );
                        return {
                            [bar]: dataset
                        }
                    })
                );
            }
        },
        mounted() {
            this.loading = true;
            const params = new URLSearchParams();
            params.append("details", "");
            this.axios.get(this.api.ACTIONS.USER_ALL_STATS, {params})
                .then(
                    ({data}) => {
                        this.data = data.data;
                    }
                ).catch(
                ({response: {data}}) => window.getApp.$emit("SHOW_TOAST", data.message, "red")
            ).finally(
                () => this.loading = false
            )
        }
    }
</script>

<style scoped>
    .widget-content {
        max-height: 20vh;
    }
</style>